import * as React from 'react';
import { SVGProps } from 'react';

const FileIconPptSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.27 8.67c.18.22.44.33.78.33H19V8h-.55c-.153 0-.267-.03-.34-.09-.073-.06-.11-.163-.11-.31V5h1V4h-1V3h-1v1h-1v1h1v2.8c0 .36.09.65.27.87ZM6.8 4.24V4H6v7h1.01V9H8.3c.58 0 1.007-.127 1.28-.38.28-.253.42-.66.42-1.22V5.6c0-.567-.137-.973-.41-1.22C9.317 4.127 8.887 4 8.3 4h-.7c-.327 0-.593.08-.8.24Zm.36.94c.107-.12.27-.18.49-.18h.6c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17H7.01L7 5.55a.53.53 0 0 1 .16-.37Zm4.63-.94V4h-.8v7H12V9h1.29c.58 0 1.007-.127 1.28-.38.28-.253.42-.66.42-1.22V5.6c0-.567-.137-.973-.41-1.22-.273-.253-.703-.38-1.29-.38h-.7c-.327 0-.593.08-.8.24Zm.36.94c.107-.12.27-.18.49-.18h.6c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17H12l-.01-2.45a.53.53 0 0 1 .16-.37Z"
      fill="#fff"
    />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 17h5a5 5 0 0 0-5-5v5Zm-2-4v6h6a6.002 6.002 0 0 1-12 0 6.002 6.002 0 0 1 6-6Zm-1 7h5.9A5.002 5.002 0 0 1 7 19a5.002 5.002 0 0 1 4-4.9V20Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconPptSizeS;
